import { render, staticRenderFns } from "./authcollapse.vue?vue&type=template&id=9e252f02&scoped=true&"
import script from "./authcollapse.vue?vue&type=script&lang=js&"
export * from "./authcollapse.vue?vue&type=script&lang=js&"
import style0 from "./authcollapse.vue?vue&type=style&index=0&id=9e252f02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e252f02",
  null
  
)

export default component.exports